import { render } from "./MovieStream.vue?vue&type=template&id=c8b57d8c&scoped=true"
import script from "./MovieStream.vue?vue&type=script&lang=js"
export * from "./MovieStream.vue?vue&type=script&lang=js"

import "./MovieStream.vue?vue&type=style&index=0&id=c8b57d8c&lang=scss&scoped=true"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b57d8c"]])

export default __exports__